import { IterableIteratorSlots, IteratorResultSlots } from '../../constants';
import { Helper } from '../Helper';
export class IterableIteratorForEachHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.unwrapIterableIterator);
        sb.emitPushInt(node, IterableIteratorSlots.next);
        sb.emitOp(node, 'PICKITEM');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, options, sb.helpers.call);
                sb.emitHelper(node, options, sb.helpers.unwrapIteratorResult);
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, IteratorResultSlots.done);
                sb.emitOp(node, 'PICKITEM');
                sb.emitHelper(node, options, sb.helpers.unwrapBoolean);
                sb.emitOp(node, 'NOT');
            },
            each: (innerOptions) => {
                sb.emitPushInt(node, IteratorResultSlots.value);
                sb.emitOp(node, 'PICKITEM');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NEWARRAY');
                sb.emitOp(node, 'SWAP');
                this.each(sb.noPushValueOptions(innerOptions));
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
        }));
    }
}

//# sourceMappingURL=IterableIteratorForEachHelper.js.map
